import { FunctionTypes } from '../../../components/ContributorSection/helpers';
var PREFIX_FOR_TEST_IDS = 'pamphlet-form';

/** test ids for form and sections inside it */
export var TestIds = {
  PAMPHLET_FORM: "".concat(PREFIX_FOR_TEST_IDS, "-test-id"),
  PAMPHLET_PUB_INFO: "".concat(PREFIX_FOR_TEST_IDS, "-pamphlet-pub-info-sec-test-id")
};
export var PamphletContributorFunctions = [FunctionTypes.AUTHOR, FunctionTypes.EDITOR, FunctionTypes.COMPILER, FunctionTypes.TRANSLATOR];
export var SECTION_TITLE = 'In print publication info';